import LoadingIndicator from "../LoadingIndicator/LoadingIndicator";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { useTranslation } from "react-i18next";

export interface DeleteDialogProps {
  entityName: string;
  deleteEntity: () => Promise<void>;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isLoading?: boolean;
}

const DeleteDialog = ({
  entityName,
  deleteEntity,
  isOpen,
  setIsOpen,
  isLoading = false,
}: DeleteDialogProps) => {
  const { t } = useTranslation("common");
  const handleDelete = async () => {
    await deleteEntity();
    setIsOpen(false);
  };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={`${t("common:delete")} ${t("common:" + entityName.toLowerCase())}`}
      action={`${t("common:deleteThis")} ${t(entityName.toLowerCase())}`}
      extraMessage={t("common:thisActionCannotBeUndone")}
      onConfirm={handleDelete}
      cancelDisabled={isLoading}
      confirmDisabled={isLoading}
      confirmText={t("common:delete")}
      confirmLeftAdornment={
        isLoading ? (
          <LoadingIndicator className="mr-2" color="inherit" size="1.25rem" />
        ) : undefined
      }
    />
  );
};

export default DeleteDialog;
